const pairPositionsCopy = {
  tableHeaderBaseAsset: 'Base Asset',
  tableHeaderCurrentQuantity: 'Current Quantity',
  tableHeaderTermAsset: 'Term Asset',
  tableHeaderMarginAsset: 'Margin Asset'
};

export default pairPositionsCopy;
